module.exports = __webpack_public_path__ + "static/media/logo.8ccc06b2.svg";